import _isEmpty from 'underscore/cjs/isEmpty.js'

import { useUtmsStore } from './utms'

export const useLifeInsuranceStore = defineStore('life-insurance', {
  state: () => ({
    guides: {
      url: null,
      initialPage: ''
    },
    form: {},
    application: {},
    lifeAip: {}
  }),

  getters: {
    leadParams () {
      const form = this.form

      if (_isEmpty(form)) {
        return {}
      }

      const utmsStore = useUtmsStore()
      const formData = flattenObj(form, 1)

      let licUpsellItems = {}
      if (formData.hasOwnProperty('lic_upsell_items')) {
        licUpsellItems = {
          lic_upsell_items: formData?.lic_upsell_items
        }
      }

      let currentLifeInsurance = {}
      if (formData.hasOwnProperty('current_life_insurance')) {
        currentLifeInsurance = {
          current_life_insurance: formData?.current_life_insurance
        }
      }
      const lifeCover = formData?.annual_income
        ? typeof formData.annual_income === 'string'
          ? formData.annual_income.replace(/[$,]/g, '')
          : formData.annual_income.toString()
        : ''

      const obj = {
        ...getName(formData?.full_name),
        age: formData?.age,
        life_cover: lifeCover,
        salary: 0,
        smoker: formData?.smoker,
        gender: formData?.gender,
        occupation: formData?.occupation?.id,
        occupationList: formData?.occupation?.name,
        occupation_omni_id: formData?.occupation?.omniumId,
        state: formData?.state,
        phone: formData?.phone,
        email: formData?.email,

        brand: 'CompareClub',
        form_page: import.meta.client && window.location.href,
        landing_page: utmsStore.GET_UTMS_LANDING_PAGE,
        trauma_sum_insured: formData.trauma_sum_insured ?? 0,
        tpd_sum_insured: formData.tpd_sum_insured ?? 0,
        viewed_quotes_c: '',
        ...licUpsellItems,
        ...currentLifeInsurance
      }

      return obj
    },
    getAipDetails () {
      return this.lifeAip
    }
  },

  actions: {
    async createLead (payload) {
      const utmsStore = useUtmsStore()

      const response = await useFetch('/api/lead/create', {
        method: 'post',
        body: {
          ...utmsStore.utms,
          ...payload,
          vertical: 'Life Insurance'
        }
      })
        .then(res => {
          const temp = res?.data.value

          if (temp?.error) {
            throw temp?.error
          }

          const data = temp?.data

          return data?.lead_uuid ?? undefined
        })
        .catch(error => {
          throw error
        })

      return response
    }
  },

  persist: {
    storage: piniaPluginPersistedstate.sessionStorage()
  }
})
